/* eslint-disable camelcase */
import { Module } from 'vuex'
import { RootState } from '../types'
import api from '@/api/axios'

export interface OccupancyItem {
  property_id: number
  property_name: string
  total_units: number
  occupied_units: number
  occupancy_rate: number
}

export interface RecentInvoice {
  id: number
  invoice_number: string
  tenant_name: string
  property_name: string
  unit_name: string
  amount: number
  due_date: string
  status: 'paid' | 'unpaid'
}

export interface DashboardStats {
  total_properties: number
  total_units: number
  occupied_units: number
  vacant_units: number
  occupancy_rate: number
  total_tenants: number
  total_income_this_month: number
  total_expenses_this_month: number
  net_profit_this_month: number
  overdue_invoices_count: number
  overdue_invoices_amount: number
  total_owners?: number
  recent_invoices: RecentInvoice[]
  occupancy_by_property: OccupancyItem[]
}

// Keep legacy type aliases so DashboardView computes still work
export type LandlordStats = DashboardStats
export type AgencyStats = DashboardStats

export interface DashboardState {
  stats: DashboardStats | null
  loading: boolean
}

const dashboard: Module<DashboardState, RootState> = {
  namespaced: true,

  state: (): DashboardState => ({
    stats: null,
    loading: false
  }),

  getters: {
    stats: (state) => state.stats,
    occupancy: (state) => state.stats?.occupancy_by_property ?? [],
    recentInvoices: (state) => state.stats?.recent_invoices ?? [],
    loading: (state) => state.loading
  },

  mutations: {
    SET_DATA (state, payload: DashboardStats) {
      state.stats = payload
    },
    SET_LOADING (state, val: boolean) { state.loading = val }
  },

  actions: {
    async fetch ({ commit }) {
      commit('SET_LOADING', true)
      try {
        const { data } = await api.get('/dashboard/stats')
        commit('SET_DATA', data.data ?? data)
      } finally {
        commit('SET_LOADING', false)
      }
    }
  }
}

export default dashboard
